import { render, staticRenderFns } from "./TopAdmin.vue?vue&type=template&id=5d84d34d&"
import script from "./TopAdmin.vue?vue&type=script&lang=js&"
export * from "./TopAdmin.vue?vue&type=script&lang=js&"
import style0 from "./TopAdmin.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports